var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H5.5C2.73858 0 0.5 2.23858 0.5 5V27C0.5 29.7614 2.73858 32 5.5 32H27.5C30.2614 32 32.5 29.7614 32.5 27V5C32.5 2.23858 30.2614 0 27.5 0Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59992 15.7083C12.8949 13.8371 15.7589 12.6034 17.1919 12.0074C21.2834 10.3056 22.1335 10.01 22.6877 10.0001C22.8095 9.99805 23.082 10.0283 23.2586 10.1715C23.4076 10.2924 23.4486 10.4558 23.4683 10.5705C23.4879 10.6851 23.5123 10.9464 23.4929 11.1505C23.2712 13.4801 22.3118 19.1335 21.8237 21.7427C21.6172 22.8468 21.2105 23.217 20.8168 23.2532C19.9613 23.3319 19.3116 22.6878 18.4829 22.1446C17.1862 21.2946 16.4537 20.7654 15.195 19.936C13.7404 18.9774 14.6834 18.4506 15.5124 17.5896C15.7293 17.3643 19.499 13.9355 19.5719 13.6244C19.5811 13.5855 19.5895 13.4405 19.5034 13.3639C19.4172 13.2874 19.2901 13.3136 19.1983 13.3344C19.0683 13.3639 16.9968 14.7331 12.9839 17.4419C12.3959 17.8457 11.8633 18.0424 11.3862 18.0321C10.8601 18.0207 9.84822 17.7346 9.09598 17.4901C8.17333 17.1902 7.44002 17.0316 7.50388 16.5223C7.53714 16.257 7.90248 15.9856 8.59992 15.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.05dd27f866d4d77e95fffe2947608ead.svg";
export { ForwardRef as ReactComponent };